import styles from './Rodape.module.css';
import { ReactComponent as MarcaRegistrada } from 'assets/marca_registrada.svg';


export default function Rodape() {
    return (
        <footer className={styles.rodape}>
            
            Hand-crafted & Made with ❤️
            <MarcaRegistrada /> <a href="https://github.com/renanaugust"  title="Repositório do Github"><u>Renan</u></a>     
        </footer>
    )
}